import React, { Fragment, useState, useEffect } from "react";
import InpuField from "../components/common/input";
import Button from "../components/common/button";
//import cookVideo from "../assets/video/cook.mp4";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../components/common/error_message";
import SuccessMessage from "../components/common/SuccessMessage";
import { Employee_Api_EndPoints } from "../global/end-points";
import * as httpService from "../services/httpService";
import Cookies from "universal-cookie";
//import logo from "../assets/images/logo.svg";
import CryptoJS from "crypto-js";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import InstallPrompt from "../components/InstallPrompt";

const spinnerStyle = {
  marginLeft: 8,
  border: "2px solid #f3f3f3",
  borderTop: "2px solid #3498db",
  borderRadius: "50%",
  width: 16,
  height: 16,
  animation: "spin 1s linear infinite",
};

function Login() {
  const initialState = {
    mobileNumber: "",
    otp: "",
    //rememberMe: false,
    UserName: "",
    AccessToken: "",
    UserId: 0,
  };

  let navigate = useNavigate();

  const [isload, setLoad] = useState(false);
  const [inputValue, setInputValue] = useState(initialState);
  const [errorMessage, setErrorMessage] = useState({ inputFields: "" });
  const [successMessage, setSuccessMessage] = useState({ inputFields: "" });
  const { inputFields } = errorMessage;
  // Add a new state variable to track OTP sent status
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [otpTimedOut, setOtpTimedOut] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [show2FA, setShow2FA] = useState(false);
  const [ssnInput, setSsnInput] = useState('');
  const [ssnError, setSsnError] = useState('');
  const [showSsn, setShowSsn] = useState(false); // New state for toggling SSN visibility

  // Timer effect for OTP resend
  useEffect(() => {
    let timer;
    if (isOtpSent && otpTimer > 0) {
      timer = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    } else if (isOtpSent && otpTimer === 0) {
      setOtpTimedOut(true);
    }
    return () => clearInterval(timer);
  }, [isOtpSent, otpTimer]);

  useEffect(() => {
    const cookies = new Cookies();
    const _loginForm = cookies.get("loginForm");
    if (_loginForm !== undefined) {
      setInputValue((prevInputValue) => ({
        ...prevInputValue,
        ..._loginForm,
      }));
    }
    setLoad(true);
  }, []);

  // Format phone number as (999) 999-9999 for display
  function formatPhoneNumber(value) {
    const digits = value.replace(/\D/g, "");
    const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return "";
    let formatted = "";
    if (match[1]) {
      formatted = `(${match[1]}`;
    }
    if (match[2]) {
      formatted += match[2] ? `) ${match[2]}` : "";
    }
    if (match[3]) {
      formatted += match[3] ? `-${match[3]}` : "";
    }
    return formatted.trim();
  }

  const handleChange = (key, value) => {
    setErrorMessage("");
    setInputValue((prevInputValue) => ({
      ...prevInputValue,
      [key]: key === "mobileNumber"
        ? value.replace(/\D/g, "").slice(0, 10) // allow max 10 digits
        : value,
    }));
  };

  const field_validation = () => {
    let isValid = true;
    if (inputValue.mobileNumber.trim() === "" && inputValue.otp.trim() === "") {
      setErrorMessage({ inputFields: "Invalid Login" });
      isValid = false;
    }
    if (inputValue.mobileNumber.trim() === "" && inputValue.otp.trim() !== "") {
      setErrorMessage({ inputFields: "Please enter the mobile number" });
      isValid = false;
    }
    if (inputValue.mobileNumber.trim() !== "" && inputValue.otp.trim() === "") {
      setErrorMessage({ inputFields: "Please enter the OTP" });
      isValid = false;
    }
    return isValid;
  };


  const handleSendOtp = async () => {
    if (inputValue.mobileNumber.trim() === "") {
      setErrorMessage({ inputFields: "Please enter the mobile number" });
      return;
    }
    setOtpTimedOut(false); // Reset timeout state
    setIsSendingOtp(true); // Start loader

    try {
      // eslint-disable-next-line no-debugger
      //debugger;
      const userDetailsResponse = await httpService.CallWithHeaders(
        'get',
        Employee_Api_EndPoints.GET_USER_DETAILS,
        { phoneNumber: inputValue.mobileNumber },
        { SecretKey: "DoUgHPaYSeCrEKeY" }
      );

      if (userDetailsResponse.status === 200) {
        const responseData = userDetailsResponse.data;

        if (Array.isArray(responseData) && responseData.length > 0) {
          const firstItem = responseData[0]; // Access the first object in the array

          if (firstItem.errorFound === false) {
            // setSuccessMessage({ inputFields: "OTP sent successfully" });
            // Prepare the body for the second API call
            const body = {
              userId: firstItem.userId, // Pass the userId from the first API response
            };
            sessionStorage.setItem("UserId", firstItem.userId);
            sessionStorage.setItem("UserName", firstItem.userName);
            sessionStorage.setItem("EmployeeId", firstItem.employeeId);
            sessionStorage.setItem("ssnNumber", firstItem.socialSecurityNumber); // <-- Add this line

            console.log("Second API Request Body:", body);
            // eslint-disable-next-line no-debugger
            //debugger;
            // Decrypt the password before sending it
            const decryptedPassword = decryptPassword(firstItem.password);


            // Authorization API call before the second API call
            const tokenKeys = {
              "UserName": firstItem.userName,
              "Password": decryptedPassword,
              "EmployeeId": firstItem.employeeId,
              "PhoneNumber": inputValue.mobileNumber
            };
            const authResponse = await httpService.Get(Employee_Api_EndPoints.AUTHORIZATION, tokenKeys);
            // eslint-disable-next-line no-debugger
            //debugger;
            if (authResponse.status === 200 && authResponse.data != null) {
              const cookies = new Cookies();
              cookies.set("AccessToken", authResponse.data?.accessToken, { path: "/" });
              cookies.set("UserName", authResponse.data?.userName);
              cookies.set("UserId", authResponse.data?.userID);

              // ✅ Store in sessionStorage as well
              sessionStorage.setItem("AccessToken", authResponse.data?.accessToken);

              // Second API call to generate OTP
              const otpResponse = await httpService.Post(Employee_Api_EndPoints.GENERATE_OTP, body);

              if (otpResponse.status === 200) {
                setSuccessMessage({ inputFields: "OTP sent successfully" });
                setIsOtpSent(true); // Set OTP sent status to true
                setOtpTimer(90); // Start 90 seconds timer
                setOtpTimedOut(false);

              } else {
                setErrorMessage({ inputFields: "Failed to send OTP" });
              }
            } else {
              setErrorMessage({ inputFields: "Authorization failed" });
            }
          } else {
            setErrorMessage({ inputFields: "Failed to send OTP" });
          }
        } else {
          setErrorMessage({ inputFields: "Failed to send OTP" });
        }
      } else {
        setErrorMessage({ inputFields: "Failed to send OTP" });
      }
    } catch (err) {
      console.error(err);
      setErrorMessage({ inputFields: "Error sending OTP" });
    } finally {
      setIsSendingOtp(false); // Stop loader
    }
  };

  // This key must match the one used on the backend (16/24/32 chars for AES-128/192/256)
  const encryptionKey = "InstaDoughAES128";
  const key = CryptoJS.enc.Utf8.parse(encryptionKey);
  const iv = CryptoJS.enc.Utf8.parse("\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0"); // 16 null bytes

  function decryptPassword(encryptedText) {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  const preloadCardRegistrationStatus = async (phoneNumber) => {
    try {
      const response = await httpService.CallWithHeaders(
        "get",
        Employee_Api_EndPoints.CARD_ACCOUNT_STATUS,
        { phoneNumber },
        { SecretKey: "DoUgHPaYSeCrEKeY" }
      );

      if (response?.status === 200 && response?.data) {
        sessionStorage.setItem(
          "CardRegistrationStatus",
          response.data.hasCard === true ? "registered" : "not_registered"
        );
      }
    } catch {
      sessionStorage.removeItem("CardRegistrationStatus");
    }
  };

  const handleClick = () => {
    if (field_validation()) {
      const loginData = {
        phoneNumber: inputValue.mobileNumber,
        validateOtp: inputValue.otp,
      };
      // eslint-disable-next-line no-debugger
      //debugger;
      httpService.Get(Employee_Api_EndPoints.VALIDATE_OTP, loginData).then(
        async (resp) => {
          if (resp.status === 200) {
            const responseData = resp.data;
            if (responseData.isvalid === false) {
              setErrorMessage({ inputFields: "Invalid OTP" });
              inputValue.otp = "";
              setInputValue({ ...inputValue });
              return;
            }
            sessionStorage.setItem('phoneNumber', inputValue.mobileNumber);
            await preloadCardRegistrationStatus(inputValue.mobileNumber);
            setShow2FA(true); // <-- Show 2FA form
            // navigate("/home"); <-- Remove this line
          } else {
            setErrorMessage({ inputFields: "Invalid Login" });
            inputValue.mobileNumber = "";
            inputValue.otp = "";
            setInputValue({ ...inputValue });
          }
        },
        (err) => {
          console.error(err);
          setErrorMessage({ inputFields: "Error during login" });
        }
      );
    }
  };

  // const handleChecked = (event) => {
  //   inputValue.rememberMe = event.target.checked;
  //   setInputValue({ ...inputValue });
  // };

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      if (!isOtpSent) {
        handleSendOtp();
      } else {
        handleClick();
      }
    }
  };

  useEffect(() => {
    if (isOtpSent && !otpTimedOut) {
      // If user edits the number while OTP is active, reset OTP state
      setIsOtpSent(false);
      setOtpTimer(0);
      setOtpTimedOut(false);
      setInputValue((prev) => ({ ...prev, otp: "" }));
    }
    // eslint-disable-next-line
  }, [inputValue.mobileNumber]);

  useEffect(() => {
    if (show2FA) {
      // Push a new state so that back button stays on the same page
      window.history.pushState(null, "", window.location.href);
      const handlePopState = () => {
        window.history.pushState(null, "", window.location.href);
      };
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [show2FA]);

  return (
    <Fragment>
      {isload && (
        <>
          <div className="login-register">
              <InstallPrompt />
            <div className="login-info-content">
              <h2>
                Get Early Access to Your Wages and Tips with EWA
              </h2>
              <p>
                Need access to your tips or wages before payday? EWA (Earned Wage Access) lets you get a portion of the money you've already earned when you need it.
              </p>
              <div>
                <b>Here’s how it works:</b>
                <ul>
                  <li>Log in to the EWA website to see how much you’ve earned so far.</li>
                  <li>Check your available balance and view your recent transactions.</li>
                  <li>Choose to transfer your money to a card - it’s quick and easy.</li>
                  <li>Looking for CASH? Access EWA directly from your kiosk to get your earned wages and tips in cash. It’s fast and easy.</li>
                </ul>
              </div>
              <p>
                <b>Why wait for payday?</b><br />
                EWA gives you the flexibility to access your earnings anytime.
              </p>
              <p>
                <b>Have questions?</b> Reach out to your manager or HR team.
              </p>
            </div>
            <div className="login-form">
              {!show2FA ? (
                <>
                  <h2 className="login-register-form-heading mt-40 mb-20">
                    Sign <span>In</span>
                  </h2>
                  <div onKeyDown={handleEnter}>
                    <div className="form-row">
                      <InpuField
                        class="input-field"
                        type="text"
                        name="mobileNumber"
                        value={formatPhoneNumber(inputValue.mobileNumber)} // display formatted
                        placeholder="Enter Mobile Number"
                        onChange={handleChange}
                        readOnly={isOtpSent && !otpTimedOut} // <-- Only readonly if OTP sent and not timed out
                      />
                    </div>
                    {/* Show Send OTP button only if OTP is NOT sent */}
                    {!isOtpSent && (
                      <div className="form-row">
                        <Button
                          label={
                            <>
                              Send OTP
                              {isSendingOtp && <span style={spinnerStyle} className="otp-spinner"></span>}
                            </>
                          }
                          className="btn btn-send-otp"
                          onClick={() => {
                            if (!isSendingOtp) {
                              handleSendOtp();
                              setOtpTimedOut(false);
                            }
                          }}
                          disabled={isSendingOtp}
                        />
                      </div>
                    )}
                    {/* Show OTP input and timer if OTP is sent */}
                    {isOtpSent && (
                      <div className="form-row otp-row-with-timer" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <InpuField
                          class="input-field"
                          type="text"
                          name="otp"
                          value={inputValue.otp}
                          placeholder="Enter OTP"
                          onChange={(key, value) => {
                            // Accept only digits, limit to 6 characters
                            const sanitized = value.replace(/\D/g, "").slice(0, 6);
                            handleChange("otp", sanitized);
                          }}
                        />
                        {/* Show timer if not timed out */}
                        {!otpTimedOut && otpTimer > 0 && (
                          <span style={{ minWidth: 60, color: "#888" }}>
                            {otpTimer}s
                          </span>
                        )}
                        {/* Show resend link if timed out */}
                        {otpTimedOut && (
                          <Button
                            label="Resend OTP"
                            className="btn btn-send-otp"
                            onClick={() => {
                              handleSendOtp();
                              setOtpTimedOut(false);
                            }}
                          />
                        )}
                      </div>
                    )}
                    {/* Show Sign In button only after OTP is sent */}
                    {isOtpSent && (
                      <div className="form-row">
                        <Button
                          label="Sign In"
                          className="btn btn-login"
                          onClick={handleClick}
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-row">
                    {/* Show error or success message in the same place */}
                    {inputFields
                      ? <ErrorMessage message={inputFields} />
                      : <SuccessMessage message={successMessage.inputFields} />
                    }
                  </div>
                  {/* <div className="form-row show-password">
                    <input
                      type="checkbox"
                      checked={inputValue.rememberMe}
                      onChange={handleChecked}
                    />
                    Remember me
                  </div> */}
                </>
              ) : (
                <div className="two-fa-card animate-fade-in">
                  <div className="two-fa-header">
                    <span className="two-fa-icon">🔒</span>
                    <h2>Two-Factor Authentication</h2>
                  </div>
                  <div className="two-fa-desc">Please enter the <b>last 4 digits</b> of your SSN to continue.</div>
                  <div className="two-fa-input-row">
                    <div className="two-fa-input-wrapper">
                      <input
                        className="two-fa-input"
                        type={showSsn ? "text" : "password"}
                        value={ssnInput}
                        onChange={e => setSsnInput(e.target.value)}
                        placeholder="Last 4 digits of SSN"
                        maxLength={4}
                        autoComplete="off"
                        onKeyDown={e => {
                          if (e.key === "Enter") {
                            const ssn = sessionStorage.getItem('ssnNumber');
                            const decryptedSSN = decryptPassword(ssn);
                            if (ssnInput === decryptedSSN.slice(-4)) {
                              navigate("/home");
                            } else {
                              setSsnError('Invalid SSN. Please try again.');
                            }
                          }
                        }}
                      />
                      <span
                        className="ssn-eye-icon"
                        onClick={() => setShowSsn(v => !v)}
                        tabIndex={0}
                        role="button"
                        aria-label={showSsn ? "Hide SSN" : "Show SSN"}
                      >
                        {showSsn ? <FaEye /> : <FaEyeSlash />}
                      </span>
                    </div>
                  </div>
                  <Button
                    label="Proceed"
                    className="btn btn-login two-fa-btn"
                    onClick={() => {
                      const ssn = sessionStorage.getItem('ssnNumber');
                      const decryptedSSN = decryptPassword(ssn);
                      if (ssnInput === decryptedSSN.slice(-4)) {
                        navigate("/home");
                      } else {
                        setSsnError('Invalid SSN. Please try again.');
                      }
                    }}
                  />
                  {ssnError && <div className="two-fa-error">{ssnError}</div>}
                </div>
              )}
            </div>
          </div>

        </>
      )}
    </Fragment>
  );
}

export default Login;
